export default {
  addBanking: {
    method: 'post',
    url: '/client/company/branch/create-banking'
  },
  updateBanking: {
    method: 'post',
    url: '/client/company/branch/update-banking'
  },
  deleteBanking: {
    method: 'delete',
    url: '/client/company/branch/delete-banking'
  },
  updateInvoice: {
    method: 'post',
    url: '/client/company/branch/update-invoice'
  }
}
